import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';

const SettingsCommonDataIndex = () => {
  document.title = "Меню";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Системийн удирдлага" breadcrumbItem="Нийтлэг өгөгдөл" />
          <Row>
            <Detail/>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default SettingsCommonDataIndex;